import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.div`
  background-image: url(${({ src }) => src});
  background-position: center;
  background-size: contain;
  width: 280px;
  height: 280px;
`;

const MaterialImage = ({ src }) => (
  <Container>
    <Image
      src={src}
      className="animate__animated animate__bounceInRight"
    />
  </Container>
);

export default MaterialImage;
